import {
  IListElementCell,
  isImgCell,
} from 'app/services/api5-service/api.interface';

import { IListCellUi } from '../../list-cell/model';

/**
 * Get image cell with specific data
 *
 * @param cell - FE cell base metadata
 * @param cellData - BE data for cell
 */
export function getImgCellWithData(
  cell: IListCellUi,
  cellData: IListElementCell,
): IListCellUi {
  cell.value = cellData.$;
  cell.verticalAlign = cell.verticalAlign || 'top';
  if (isImgCell(cellData)) {
    cell.isSvgSprite = cellData.$spritesvg === 'yes';
    cell.img = cellData.$img;
    cell.trackBy = cellData.$img;
  }
  return cell;
}
